export default __webpack_public_path__ + "static/media/CTP_Dark_EN.5056628c.svg";